export const SubcategoryNameInputStyles = {
  '& .MuiOutlinedInput-root': {
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: 'white',
    borderRadius: '16px !important',
  },
};
